exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contentCert[data-v-7f052582]{padding:1.8em 3em;background:hsla(0,0%,100%,.6);text-align:center;border-radius:.2rem;color:rgba(0,0,0,.6);box-shadow:2px 2px 25px 0 rgba(46,61,73,.1)}@media (max-width:575px){.contentCert[data-v-7f052582]{padding:1em;padding-top:2em}.backgroundCert[data-v-7f052582]{padding:1em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f052582","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/course/CourseCertificate.vue
// module id = 237
// module chunks = 0